import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotateBack } from "@fortawesome/free-solid-svg-icons";
import { useGetLogsQuery } from "../store/slices/settingsSlice";
import MyPagination from "../Common/MyPagination";
import MyModal from "../Common/MyModal";

export default function MonitoringLogs({
  monitor,
  fetchMonitor,
}: {
  monitor: any;
  fetchMonitor: () => void;
}) {
  const [paginations, setPaginations] = useState({ offset: 0, limit: 12 });
  const { data, refetch } = useGetLogsQuery(
    {
      resource: monitor.Uuid,
      kind: ["monitor"],
      ...paginations,
    },
    { skip: !monitor?.Uuid }
  );
  return (
    <div className="my-4">
      {monitor.CurrentStatus && monitor.Kind !== "weather" && (
        <div className="mb-4 p-3 rounded-3 bg-white">
          <h5 className="d-inline">
            Current Status
            <button
              className="btn p-0 ms-3"
              onClick={() => fetchMonitor()}
              title="Refresh status"
            >
              <FontAwesomeIcon icon={faRotateBack} />
            </button>
          </h5>
          <table className="table table-sm mb-2">
            <tbody>
              <tr>
                <th>Created at</th>{" "}
                <td>
                  {monitor?.CurrentStatus?.CreatedAt
                    ? new Date(
                        monitor.CurrentStatus.CreatedAt * 1000
                      ).toLocaleString()
                    : "—"}
                </td>
              </tr>
              <tr>
                <th>Last check</th>{" "}
                <td>
                  {monitor?.CurrentStatus?.LastCheckAt
                    ? new Date(
                        monitor.CurrentStatus.LastCheckAt * 1000
                      ).toLocaleString()
                    : "—"}
                </td>
              </tr>
              <tr>
                <th>Ping Status</th>{" "}
                <td>
                  <span
                    className={
                      "badge " +
                      (monitor?.CurrentStatus?.Status === "ok"
                        ? "bg-success"
                        : "bg-danger")
                    }
                  >
                    {monitor?.CurrentStatus?.Status ?? "—"}
                  </span>
                </td>
              </tr>
              <tr>
                <th>Count</th>
                <td>{monitor?.CurrentStatus?.Count ?? "—"}</td>
              </tr>
              <tr>
                <th>Next run</th>
                <td>
                  {monitor?.CurrentStatus?.NextRun
                    ? new Date(monitor.CurrentStatus.NextRun).toLocaleString()
                    : "—"}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
      <button className="btn btn-link float-end" onClick={() => refetch()}>
        <FontAwesomeIcon icon={faRotateBack} />
      </button>
      <table className="table">
        <thead>
          <tr>
            <th>Created at</th>
            <th>Level</th>
            <th>Message</th>
            <th>User</th>
            <th>Data</th>
          </tr>
        </thead>
        <tbody>
          {data?.logs?.map((log: any) => (
            <tr key={log.Id}>
              <td>{log.CreatedAt}</td>
              <td>{log.Level}</td>
              <td>{log.Message}</td>
              <td>{log.User}</td>
              <td>
                {log.Data ? (
                  <MyModal
                    heading="Log Data"
                    label="View Data"
                    size="lg"
                    buttonClassName="btn-secondary px-1"
                  >
                    <div className="my-3">
                      <pre>{JSON.stringify(log.Data, null, 2)}</pre>
                    </div>
                  </MyModal>
                ) : (
                  "{}"
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <MyPagination
        onPaginate={(page: number, perPage: number) => {
          setPaginations({ offset: page * perPage, limit: perPage });
        }}
        total={data?.total || 0}
      />
    </div>
  );
}
